import axios from "axios";

import myConfig from "../../configs/config";

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem("client-token")}`,
  };
}

export async function fetchTrackHeadingPresets({
  farmId,
  serviceType,
  serviceFarmId,
}) {
  const params = { farm_id: farmId };
  if (serviceType) params.service_type = serviceType;
  if (serviceFarmId) params.service_farm_id = serviceFarmId;

  const response = await axios.get(`${myConfig.API_URL}/track-heading-preset/`, {
    params,
    headers: authHeaders(),
  });
  return Array.isArray(response.data)
    ? response.data
    : response.data.results || [];
}

export async function createTrackHeadingPreset(payload) {
  const response = await axios.post(
    `${myConfig.API_URL}/track-heading-preset/`,
    payload,
    { headers: authHeaders() }
  );
  return response.data;
}

export async function fetchTrackHeadingPresetLandPlots(presetId) {
  const response = await axios.get(
    `${myConfig.API_URL}/track-heading-preset/${presetId}/`,
    { headers: authHeaders() }
  );
  return response.data;
}

export async function fetchPublishedFarmMapTrackHeadings(farmId) {
  const response = await axios.get(`${myConfig.API_URL}/track-heading-preset/`, {
    params: {
      farm_id: farmId,
      published_on_farm_map: true,
    },
    headers: authHeaders(),
  });
  return Array.isArray(response.data)
    ? response.data
    : response.data.results || [];
}

export async function updateTrackHeadingPreset(presetId, payload) {
  const response = await axios.patch(
    `${myConfig.API_URL}/track-heading-preset/${presetId}/`,
    payload,
    { headers: authHeaders() }
  );
  return response.data;
}

export async function unpublishTrackHeadingFromFarmMap(presetId) {
  return updateTrackHeadingPreset(presetId, {
    published_on_farm_map: false,
  });
}
